import { Checkbox, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { MRT_RowData, MRT_TableInstance } from 'material-react-table'
import { TomTableDataExportProps, useMinimalsTheme } from '../../../../hooks'
import { TomTableActions, TomTableActionsProps } from '../molecules/TomTableActions'
import { TomTableExportButton } from '../molecules/TomTableExportButton'

export const TomTableToolbarAlertBanner = <TData extends MRT_RowData>(props: {
  table: MRT_TableInstance<TData>
  tableActions?: TomTableActionsProps<TData>[]
  dataExport?: TomTableDataExportProps<TData>
}) => {
  const { table, tableActions, dataExport } = props
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  return (
    <Stack
      direction='row'
      sx={{ backgroundColor: theme.palette.grey[300] }}
      spacing={theme.customSpacing.m}
      alignItems='center'
    >
      <Stack direction='row' gap={theme.customSpacing.s} alignItems='center'>
        <Checkbox
          color='default'
          checked={table.getIsAllRowsSelected()}
          indeterminate={table.getIsSomeRowsSelected()}
          onChange={table.getToggleAllRowsSelectedHandler()}
        />
        <Typography variant='body1' color='textPrimary'>
          {t('xItemsSelected', '{count} items selected', {
            count: table.getSelectedRowModel().rows.length,
          })}
        </Typography>
      </Stack>
      {dataExport && dataExport.enableDataExport && (
        <TomTableExportButton
          workbookTitle={dataExport.title}
          table={table}
          config={dataExport.dataExportConfig}
          customExportCsv={dataExport.customExportCsv}
          customExportXlsx={dataExport.customExportXlsx}
        />
      )}
      {tableActions && <TomTableActions table={table} tableActions={tableActions} />}
    </Stack>
  )
}
